import { render } from "./DashSettlement.vue?vue&type=template&id=ee685ce6&scoped=true&ts=true"
import script from "./DashSettlement.vue?vue&type=script&lang=ts"
export * from "./DashSettlement.vue?vue&type=script&lang=ts"

import "./DashSettlement.vue?vue&type=style&index=0&id=ee685ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee685ce6"]])

export default __exports__